import { GapSection, TheGap } from './index';
import { heroUnits } from '../heroUnits';

// Review-only preview of the gap visual (route /__gap). Owned by the story build agent.
export default function Preview() {
  return (
    <div>
      <GapSection tone="light" />
      <GapSection tone="dark" id="the-gap-dark" unit={heroUnits[1]} />
      <GapSection compact id="the-gap-compact" unit={heroUnits[2]} />
      <section className="section" style={{ background: '#F7F7FC' }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <div className="t-eyebrow" style={{ marginBottom: 16 }}>Diagram only, compact, 820px</div>
          <TheGap compact unit={heroUnits[3]} />
        </div>
      </section>
    </div>
  );
}
